import { ActionTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyPictureTypesStore from "./property-picture-types.store";
import { IListing } from "../../../../models/listing-base-model";
import { IPropertyPictureModel } from "../../../../models/property";


const pictureActions = <ActionTree<IPropertyEditState, any>>{
	[propertyPictureTypesStore.Get.LIST_OF_PROPERTY_PICTURES]: ({ getters, commit }, param: number) => {
		return getters.service[propertyPictureTypesStore.Service.LIST_OF_PROPERTY_PICTURES](param)
			.then((listingResult: IListing<IPropertyPictureModel>) => {				
				listingResult.listOfItems.sort((a, b) => {return a.PictureNumber - b.PictureNumber});
				commit(propertyPictureTypesStore.Set.LIST_OF_PROPERTY_PICTURES, listingResult);
				return Promise.resolve(listingResult);
			})
			.catch(error => Promise.reject(error))
	}
}

export default pictureActions;